
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Group 140913","xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 151100","d":"M11.828 15.899a.781.781 0 001.137 0A.822.822 0 0013 14.727l-4.412-4.652L13 5.422a.822.822 0 00-.035-1.171.781.781 0 00-1.137 0L6.865 9.489a.832.832 0 000 1.172z","fill":"#8d98aa"}})])
          )
        }
      }
    